import React, { PureComponent } from 'react'
import { string, shape, any } from 'prop-types'
import { Alert } from 'reactstrap'
import isEqual from 'lodash/isEqual'

import { emptyAlert } from 'utils/generators/alert'

export default class AlertComponent extends PureComponent {
    static propTypes = {
        alert: shape({
            children: any.isRequired,
            footer: any,
            id: string.isRequired,
            title: any,
            color: string.isRequired
        }).isRequired
    }

    state = {
        visible: false
    }

    componentWillUpdate(nextProps) {
        if (isEqual(this.props.alert, emptyAlert) && !isEqual(nextProps.alert !== emptyAlert)) {
            this.setState({ visible: true })
        }
    }

    onHide = () => {
        this.setState({ visible: false }, this.props.dismissAlert)
    }

    onConfirm = onClick => {
        onClick()
        this.onHide()
    }

    render() {
        const { visible } = this.state
        const { alert } = this.props
        const { children, id, title, color, footer } = alert

        return (
            <Alert isOpen={visible} color={color} id={id} toggle={alert.dismiss ? this.onHide : null}>
                {title ? <h4 className="alert-heading">{title}</h4> : null}
                {children}

                {footer ? (
                    <div>
                        <hr />
                        <p className="mb-0">{footer}</p>
                    </div>
                ) : null}
            </Alert>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Alert/Alert.js